module.exports = {
          srcSet: __webpack_public_path__ + "images/2022-40b95ba6ff2344f469065336bf6ea44d-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/2022-f68a040ca953f9fe34d2c565dafa74eb-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/2022-40b95ba6ff2344f469065336bf6ea44d-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/2022-f68a040ca953f9fe34d2c565dafa74eb-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/2022-40b95ba6ff2344f469065336bf6ea44d-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/2022-40b95ba6ff2344f469065336bf6ea44d-320.jpg"},
          
          width: 320,
          height: 251
        }